import { appConfig } from '../../config';

const AUTH_API_BASE = appConfig.authApiBaseUrl;

export class SsoError extends Error {
    constructor(code) { super(code); this.code = code; }
}

async function publicAuthRequest(path, options = {}) {
    let response;
    try {
        response = await fetch(`${AUTH_API_BASE}${path}`, {
            ...options,
            credentials: 'omit',
            cache: 'no-store',
            redirect: 'error',
            referrerPolicy: 'no-referrer',
            headers: {Accept: 'application/json', ...options.headers},
        });
    } catch (error) { throw new SsoError('sso_network_error'); }
    const body = await response.json().catch(() => null);
    if (!response.ok) {
        throw new SsoError(response.status === 429 ? 'sso_rate_limited' : body?.data?.code || 'sso_request_failed');
    }
    if (!body?.data || typeof body.data !== 'object') throw new SsoError('sso_invalid_payload');
    return body.data;
}

export async function getSsoEnabled() {
    const data = await publicAuthRequest('/sso/status/');
    return data.enabled === true;
}

export function startSsoLogin() { window.location.assign(`${AUTH_API_BASE}/sso/login/`); }

export async function exchangeSsoCode(code) {
    if (typeof code !== 'string' || !code || code.length > 255) throw new SsoError('sso_invalid_callback');
    const data = await publicAuthRequest('/sso/exchange/', {
        method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({code}),
    });
    if (![data.access, data.refresh, data.role].every((value) => typeof value === 'string' && value.length > 0)) {
        throw new SsoError('sso_invalid_payload');
    }
    return data;
}
